import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClinicaService {

  private readonly keyClinica = 'clinica';
  private readonly keyClinicaId = 'clinicaId';

  constructor() {
    var stored = localStorage.getItem(this.keyClinica);
    if (stored) {
      this.clinica = stored;
    }

    stored = localStorage.getItem(this.keyClinicaId);
    if (stored) {
      this.clinicaId = stored;
    }

  }

  private _clinicaName: string = '';
  private _clinicaId: string = '';

  get clinica(): string {
    return this._clinicaName;
  }

  set clinica(value: string) {
    this._clinicaName = value;
    localStorage.setItem(this.keyClinica, value);
  }

  get clinicaId(): string {
    return this.clinicaId;
  }

  set clinicaId(value: string) {
    this._clinicaId = value;
    localStorage.setItem(this.keyClinicaId, value);
  }

  clearClinicaName(): void {
    this._clinicaName = '';
    localStorage.removeItem(this.keyClinica);
  }

  getClinicaName(): string {
    if (!this._clinicaName) {
      const stored = localStorage.getItem(this.keyClinica);
      if (stored) {
        this._clinicaName = stored;
      } else {
        return null;
      }
    }
    return this._clinicaName;
  }

  getClinicaId(): string {
    if (!this._clinicaId) {
      const stored = localStorage.getItem(this.keyClinicaId);
      if (stored) {
        this.clinicaId = stored;
      } else {
        return null;
      }
    }
    return this._clinicaId;
  }

  clearClinicaId(): void {
    this._clinicaId = '';
    localStorage.removeItem(this.keyClinicaId);
  }
}
